var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhotoCamera2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 57.601562 13 L 52 13 L 52 9 L 38 9 L 38 13 L 32 13 L 32 12.398438 L 33.699219 10.699219 C 34.101562 10.300781 34.101562 9.699219 33.699219 9.300781 C 33.300781 8.898438 32.699219 8.898438 32.300781 9.300781 L 30 11.601562 L 30 13 L 27 13 L 27 11.601562 L 24.699219 9.300781 C 24.300781 8.898438 23.699219 8.898438 23.300781 9.300781 C 22.898438 9.699219 22.898438 10.300781 23.300781 10.699219 L 25 12.398438 L 25 13 L 16.398438 13 L 12.433594 20 L 12 20 L 12 18 C 12 16.898438 11.101562 16 10 16 L 5 16 C 3.898438 16 3 16.898438 3 18 L 3 20 L 2.5 20 C 1.101562 20 0 21.101562 0 22.5 L 0 48.601562 C 0 50.5 1.5 52 3.398438 52 L 29.699219 52 C 29.800781 52 29.898438 52 30 52 C 30.101562 52 30.101562 52 30.199219 52 L 56.601562 52 C 58.5 52 60 50.5 60 48.601562 L 60 15.398438 C 60 14.101562 58.898438 13 57.601562 13 Z M 40 11 L 50 11 L 50 13 L 40 13 Z M 5 18 L 10 18 L 10 20 L 5 20 Z M 2 22.5 C 2 22.199219 2.199219 22 2.5 22 L 16.699219 22 C 15.335938 23.5 14.265625 25.183594 13.496094 27 L 2 27 Z M 12 42 C 11.398438 42 11 42.398438 11 43 L 9 43 C 9 42.398438 8.601562 42 8 42 C 7.398438 42 7 42.398438 7 43 L 5 43 C 5 42.398438 4.601562 42 4 42 C 3.398438 42 3 42.398438 3 43 L 2 43 L 2 42 C 2.601562 42 3 41.601562 3 41 C 3 40.398438 2.601562 40 2 40 L 2 38 C 2.601562 38 3 37.601562 3 37 C 3 36.398438 2.601562 36 2 36 L 2 34 C 2.601562 34 3 33.601562 3 33 C 3 32.398438 2.601562 32 2 32 L 2 30 C 2.601562 30 3 29.601562 3 29 L 5 29 C 5 29.601562 5.398438 30 6 30 C 6.601562 30 7 29.601562 7 29 L 9 29 C 9 29.601562 9.398438 30 10 30 C 10.601562 30 11 29.601562 11 29 L 12.699219 29 C 12.589844 29.351562 12.496094 29.710938 12.414062 30.074219 C 12.289062 30.027344 12.152344 30 12 30 C 11.398438 30 11 30.398438 11 31 C 11 31.601562 11.398438 32 12 32 C 12.035156 32 12.066406 32 12.101562 31.996094 C 12.03125 32.660156 12 33.328125 12 34 C 11.398438 34 11 34.398438 11 35 C 11 35.601562 11.398438 36 12 36 C 12.035156 36 12.074219 36 12.109375 35.996094 C 12.183594 36.703125 12.296875 37.402344 12.453125 38.089844 C 12.320312 38.03125 12.167969 38 12 38 C 11.398438 38 11 38.398438 11 39 C 11 39.601562 11.398438 40 12 40 C 12.386719 40 12.6875 39.832031 12.855469 39.554688 C 12.949219 39.847656 13.050781 40.132812 13.15625 40.421875 C 13.054688 40.578125 13 40.773438 13 41 C 13 41.546875 13.332031 41.925781 13.847656 41.988281 C 14.019531 42.332031 14.203125 42.667969 14.398438 43 L 13 43 C 13 42.398438 12.601562 42 12 42 Z M 3.398438 50 C 2.601562 50 2 49.398438 2 48.601562 L 2 45 L 15.867188 45 C 16.535156 45.859375 17.28125 46.664062 18.101562 47.398438 C 19.199219 48.398438 20.5 49.300781 21.800781 50 Z M 30.101562 50 L 29.699219 50 C 25.898438 49.898438 22.199219 48.5 19.300781 45.898438 C 18.695312 45.367188 18.140625 44.789062 17.632812 44.171875 L 17.101562 43.398438 C 15.234375 40.789062 14.15625 37.832031 14.015625 34.6875 C 14.015625 34.652344 14.011719 34.613281 14.011719 34.574219 C 14.003906 34.382812 14 34.191406 14 34 C 14 29.300781 16.101562 24.800781 19.699219 21.800781 C 22.601562 19.300781 26.199219 18 30 18 C 33.414062 18 36.671875 19.050781 39.398438 21.078125 L 40.199219 21.800781 C 44.398438 25.300781 46.5 30.601562 45.800781 36 C 45 43.199219 39.101562 49.101562 31.800781 49.898438 C 31.199219 50 30.601562 50 30.101562 50 Z M 47.585938 37.925781 C 47.707031 37.972656 47.847656 38 48 38 C 48.601562 38 49 37.601562 49 37 C 49 36.398438 48.601562 36 48 36 C 47.972656 36 47.945312 36 47.921875 36.003906 C 47.988281 35.335938 48.023438 34.664062 48.015625 34 C 48.605469 33.992188 49 33.59375 49 33 C 49 32.398438 48.601562 32 48 32 C 47.964844 32 47.933594 32 47.902344 32.003906 C 47.828125 31.296875 47.714844 30.597656 47.550781 29.910156 C 47.683594 29.96875 47.832031 30 48 30 C 48.601562 30 49 29.601562 49 29 L 51 29 C 51 29.601562 51.398438 30 52 30 C 52.601562 30 53 29.601562 53 29 L 55 29 C 55 29.601562 55.398438 30 56 30 C 56.601562 30 57 29.601562 57 29 L 58 29 L 58 30 C 57.398438 30 57 30.398438 57 31 C 57 31.601562 57.398438 32 58 32 L 58 34 C 57.398438 34 57 34.398438 57 35 C 57 35.601562 57.398438 36 58 36 L 58 38 C 57.398438 38 57 38.398438 57 39 C 57 39.601562 57.398438 40 58 40 L 58 42 C 57.398438 42 57 42.398438 57 43 L 55 43 C 55 42.398438 54.601562 42 54 42 C 53.398438 42 53 42.398438 53 43 L 51 43 C 51 42.398438 50.601562 42 50 42 C 49.398438 42 49 42.398438 49 43 L 45.601562 43 C 46.519531 41.453125 47.171875 39.769531 47.5625 38.015625 C 47.570312 37.984375 47.578125 37.957031 47.585938 37.925781 Z M 58 48.601562 C 58 49.398438 57.398438 50 56.601562 50 L 38.199219 50 C 40.550781 48.777344 42.597656 47.066406 44.203125 45 L 58 45 Z M 58 27 L 46.5625 27 C 45.789062 25.175781 44.726562 23.480469 43.398438 22 L 46 22 L 46 23.199219 C 46 24.199219 46.800781 25 47.800781 25 L 54.199219 25 C 55.199219 25 56 24.199219 56 23.199219 L 56 22 L 58 22 Z M 48 20 L 48 18 L 54 18 L 54 23 L 48 23 Z M 56 20 L 56 17.800781 C 56 16.800781 55.199219 16 54.199219 16 L 47.800781 16 C 46.800781 16 46 16.800781 46 17.800781 L 46 20 L 41.300781 20 C 38.101562 17.398438 34.101562 16 30 16 C 25.898438 16 21.898438 17.398438 18.699219 20 L 14.699219 20 L 17.601562 15 L 57.601562 15 C 57.800781 15 58 15.199219 58 15.398438 L 58 20 Z M 56 20 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "M 30 21 C 22.800781 21 17 26.800781 17 34 C 17 41.199219 22.800781 47 30 47 C 37.199219 47 43 41.199219 43 34 C 43 26.800781 37.199219 21 30 21 Z M 30 45 C 23.898438 45 19 40.101562 19 34 C 19 27.898438 23.898438 23 30 23 C 36.101562 23 41 27.898438 41 34 C 41 40.101562 36.101562 45 30 45 Z M 30 45 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "M 37.699219 36.300781 C 37.300781 35.898438 36.699219 35.898438 36.300781 36.300781 L 32.300781 40.300781 C 31.898438 40.699219 31.898438 41.300781 32.300781 41.699219 C 32.5 41.898438 32.699219 42 33 42 C 33.300781 42 33.5 41.898438 33.699219 41.699219 L 37.699219 37.699219 C 38.101562 37.300781 38.101562 36.699219 37.699219 36.300781 Z M 37.699219 36.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "M 36.699219 32.300781 C 36.300781 31.898438 35.699219 31.898438 35.300781 32.300781 L 28.300781 39.300781 C 27.898438 39.699219 27.898438 40.300781 28.300781 40.699219 C 28.5 40.898438 28.699219 41 29 41 C 29.300781 41 29.5 40.898438 29.699219 40.699219 L 36.699219 33.699219 C 37.101562 33.300781 37.101562 32.699219 36.699219 32.300781 Z M 36.699219 32.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 27 10 L 30 10 C 30.601562 10 31 9.601562 31 9 C 31 8.398438 30.601562 8 30 8 L 27 8 C 26.398438 8 26 8.398438 26 9 C 26 9.601562 26.398438 10 27 10 Z M 27 10 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 8 32 C 8.601562 32 9 31.601562 9 31 C 9 30.398438 8.601562 30 8 30 C 7.398438 30 7 30.398438 7 31 C 7 31.601562 7.398438 32 8 32 Z M 8 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 4 32 C 4.601562 32 5 31.601562 5 31 C 5 30.398438 4.601562 30 4 30 C 3.398438 30 3 30.398438 3 31 C 3 31.601562 3.398438 32 4 32 Z M 4 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 6 34 C 6.601562 34 7 33.601562 7 33 C 7 32.398438 6.601562 32 6 32 C 5.398438 32 5 32.398438 5 33 C 5 33.601562 5.398438 34 6 34 Z M 6 34 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 10 34 C 10.601562 34 11 33.601562 11 33 C 11 32.398438 10.601562 32 10 32 C 9.398438 32 9 32.398438 9 33 C 9 33.601562 9.398438 34 10 34 Z M 10 34 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 8 34 C 7.398438 34 7 34.398438 7 35 C 7 35.601562 7.398438 36 8 36 C 8.601562 36 9 35.601562 9 35 C 9 34.398438 8.601562 34 8 34 Z M 8 34 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 4 36 C 4.601562 36 5 35.601562 5 35 C 5 34.398438 4.601562 34 4 34 C 3.398438 34 3 34.398438 3 35 C 3 35.601562 3.398438 36 4 36 Z M 4 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 6 36 C 5.398438 36 5 36.398438 5 37 C 5 37.601562 5.398438 38 6 38 C 6.601562 38 7 37.601562 7 37 C 7 36.398438 6.601562 36 6 36 Z M 6 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 10 36 C 9.398438 36 9 36.398438 9 37 C 9 37.601562 9.398438 38 10 38 C 10.601562 38 11 37.601562 11 37 C 11 36.398438 10.601562 36 10 36 Z M 10 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 8 38 C 7.398438 38 7 38.398438 7 39 C 7 39.601562 7.398438 40 8 40 C 8.601562 40 9 39.601562 9 39 C 9 38.398438 8.601562 38 8 38 Z M 8 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 4 38 C 3.398438 38 3 38.398438 3 39 C 3 39.601562 3.398438 40 4 40 C 4.601562 40 5 39.601562 5 39 C 5 38.398438 4.601562 38 4 38 Z M 4 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 6 40 C 5.398438 40 5 40.398438 5 41 C 5 41.601562 5.398438 42 6 42 C 6.601562 42 7 41.601562 7 41 C 7 40.398438 6.601562 40 6 40 Z M 6 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 10 40 C 9.398438 40 9 40.398438 9 41 C 9 41.601562 9.398438 42 10 42 C 10.601562 42 11 41.601562 11 41 C 11 40.398438 10.601562 40 10 40 Z M 10 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 52 40 C 51.398438 40 51 40.398438 51 41 C 51 41.601562 51.398438 42 52 42 C 52.601562 42 53 41.601562 53 41 C 53 40.398438 52.601562 40 52 40 Z M 52 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 48 42 C 48.601562 42 49 41.601562 49 41 C 49 40.398438 48.601562 40 48 40 C 47.398438 40 47 40.398438 47 41 C 47 41.601562 47.398438 42 48 42 Z M 48 42 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 56 40 C 55.398438 40 55 40.398438 55 41 C 55 41.601562 55.398438 42 56 42 C 56.601562 42 57 41.601562 57 41 C 57 40.398438 56.601562 40 56 40 Z M 56 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 54 38 C 53.398438 38 53 38.398438 53 39 C 53 39.601562 53.398438 40 54 40 C 54.601562 40 55 39.601562 55 39 C 55 38.398438 54.601562 38 54 38 Z M 54 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 50 40 C 50.601562 40 51 39.601562 51 39 C 51 38.398438 50.601562 38 50 38 C 49.398438 38 49 38.398438 49 39 C 49 39.601562 49.398438 40 50 40 Z M 50 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 52 38 C 52.601562 38 53 37.601562 53 37 C 53 36.398438 52.601562 36 52 36 C 51.398438 36 51 36.398438 51 37 C 51 37.601562 51.398438 38 52 38 Z M 52 38 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 56 36 C 55.398438 36 55 36.398438 55 37 C 55 37.601562 55.398438 38 56 38 C 56.601562 38 57 37.601562 57 37 C 57 36.398438 56.601562 36 56 36 Z M 56 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 54 36 C 54.601562 36 55 35.601562 55 35 C 55 34.398438 54.601562 34 54 34 C 53.398438 34 53 34.398438 53 35 C 53 35.601562 53.398438 36 54 36 Z M 54 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 50 36 C 50.601562 36 51 35.601562 51 35 C 51 34.398438 50.601562 34 50 34 C 49.398438 34 49 34.398438 49 35 C 49 35.601562 49.398438 36 50 36 Z M 50 36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 52 34 C 52.601562 34 53 33.601562 53 33 C 53 32.398438 52.601562 32 52 32 C 51.398438 32 51 32.398438 51 33 C 51 33.601562 51.398438 34 52 34 Z M 52 34 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 56 34 C 56.601562 34 57 33.601562 57 33 C 57 32.398438 56.601562 32 56 32 C 55.398438 32 55 32.398438 55 33 C 55 33.601562 55.398438 34 56 34 Z M 56 34 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 54 32 C 54.601562 32 55 31.601562 55 31 C 55 30.398438 54.601562 30 54 30 C 53.398438 30 53 30.398438 53 31 C 53 31.601562 53.398438 32 54 32 Z M 54 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#020842",
      fillOpacity: 1
    },
    d: "M 50 32 C 50.601562 32 51 31.601562 51 31 C 51 30.398438 50.601562 30 50 30 C 49.398438 30 49 30.398438 49 31 C 49 31.601562 49.398438 32 50 32 Z M 50 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "M 30 35 C 30.601562 35 31 34.601562 31 34 C 31 33.398438 30.601562 33 30 33 C 29.398438 33 29 33.398438 29 34 C 29 34.601562 29.398438 35 30 35 Z M 30 35 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotoCamera2);
export default __webpack_public_path__ + "static/media/icon_photo_camera_2.2770628812fa23625a22329e21e19399.svg";
export { ForwardRef as ReactComponent };